export const CACHE_KEY = "cachedreq";
export const STORAGE_REQ_KEY = 'storedreq'
export const secretKey =
  "MIICXAIBAAKBgQDfmlc2EgrdhvakQApmLCDOgP0nNERInBheMh7J/r5aU8PUAIpGXET/8";
export const isLive = false;
